import React, { useEffect, useState } from "react";
import CityStore from "../store/CityStore";
import CategoryStore from "../store/CategoryStore";
import { useNavigate } from "react-router-dom";
import CountryStore from "../store/CountryStore";
import CategoryListStore from "../store/CategoryListStore";

function BrowseByCities({ cityData }) {
  const navigate = useNavigate();
  const setGlobalCategory = CategoryStore((state) => state.setCategory);
  const globalCategoryList = CategoryListStore((state) => state.categoryList);
  const country = CountryStore((state) => state.country);
  const [category, setCategory] = useState("panel");
  const setCity = CityStore((state) => state.setCity);

  const [activeTab, setActiveTab] = useState("panel");
  const [categoryData, setCategoryData] = useState([]);

  // async function fetchData() {
  //   try {
  //     const response = await fetch(
  //       "https://elsopro.com/api/get_sub_category.php",
  //       {
  //         method: "GET",
  //       }
  //     );

  //     const text = await response.text();
  //     const cleanedText = text.replace(/[^{}[\],:\"\s0-9a-zA-Z]/g, "");
  //     const parts = cleanedText.split("}{");

  //     const jsonParts = parts.map((part, index) => {
  //       if (index === 0) return part + "}";
  //       if (index === parts.length - 1) return "{" + part;
  //       return "{" + part + "}";
  //     });

  //     try {
  //       const categoryData = JSON.parse(jsonParts[0]);
  //       const countryData = JSON.parse(jsonParts[1]);
  //       const responseCountData = JSON.parse(jsonParts[2]);

  //       if (categoryData.category && Array.isArray(categoryData.category)) {
  //         setCategoryData(categoryData.category);
  //       }
  //     } catch (parseError) {
  //       console.error("Error parsing JSON parts:", parseError);
  //       setCategoryData([]);
  //     }
  //   } catch (e) {
  //     console.error("Error fetching or processing the response:", e);
  //     setCategoryData([]);
  //   }
  // }

  useEffect(() => {
    // fetchData();
    setCategoryData(Object.keys(globalCategoryList));
    // console.log(categoryData);
  }, []);

  function handleClick(item) {
    // console.log(item);
    setCity(item);
    setGlobalCategory(category);
    const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
    const formattedCategory = category.replace(/\s+/g, "-").toLowerCase();
    const formattedCity = item.trim().replace(/\s+/g, "-").toLowerCase();
    // console.log(formattedCity);
    navigate(
      `/${formattedCountry}/${formattedCity}/${formattedCategory}`
    );
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  function handleCategory(slug) {
    setActiveTab(slug);
    setCategory(slug);
  }

  const cities = Array.isArray(cityData) ? cityData : [];

  return (
    <div className="py-4 font-inter border-b-2 border-t-2 mt-4">
      <h2 className="text-black text-2xl 2xl:text-3xl my-4 pl-2">
        <strong>Browse By Cities</strong>
      </h2>
      <div className="flex flex-wrap gap-4 xl:gap-16 2xl:gap-20 my-8 p-2 pb-0 border-b-2 gap-12 border-gray-300">
        {categoryData.map((category) => (
          <button
            key={category}
            onClick={() => handleCategory(category)}
            className={`pb-2 text-lg ${
              activeTab === category
                ? "border-b-2 border-black text-black"
                : "text-[#9CA3AF]"
            } hover:text-black transition`}
          >
            {category[0].toUpperCase() + category.slice(1)}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-8 pl-2 2xl:pl-6 overflow-hidden">
        {cities.length > 0 ? (
          <>
            {cities.slice(0, 13).map((city, index) => (
              <button
                key={index}
                className="text-gray-600 text-left hover:text-black cursor-pointer text-base 2xl:text-lg truncate"
                onClick={() => handleClick(city.city_name)}
              >
                {city.city_name}
              </button>
            ))}
            {cities.length > 14 && (
              <button
                className="text-gray-600 text-left hover:text-black cursor-pointer text-base 2xl:text-lg"
                onClick={() =>
                  navigate("/city", { state: { cityData: cities } })
                }
              >
                View more . . .
              </button>
            )}
          </>
        ) : (
          <div className="col-span-full text-gray-600">No cities available</div>
        )}
      </div>
    </div>
  );
}

export default BrowseByCities;